import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PaymentMethodPrimeList from './PaymentMethodPrimeList'
import WalletService from 'services/Wallet'
import Loader from 'components/Loader'
import PubSub from 'services/PubSub'
import AddCardsContent from './AddCardsContent'
import { actionsType } from 'config/constants'
import { walletPaymentsName } from 'config'
import style from './style.scss' //NOSONAR

let actions = []

const ContainerPaymentMethodPrime = (props) => {
    const {callbackOnClick, payload} = props

    const [isLoading, setLoading] = useState(true)
    const [loadingInit, setLoadingInit] = useState(false)
    const [cardsList, setCardsList] = useState(false)

    useEffect(() => {
        actions.push(PubSub.register('update_card_list', updateCardList))
        getCards()
        return function cleanup() {
            actions.map((token) => PubSub.unregister(token))
            actions = []
        }
    }, [])

    const updateCardList = (payload) => {
        if (payload && payload.value) {
            setCardsList(payload.value)
            setLoading(false)
        }
    }

    const getCards = () => {
        setLoading(true)
        setLoadingInit(true)

        WalletService.getWalletCards()
            .then((data) => {
                if (data?.results) {
                    setLoading(false);
                    const _cardsList = data?.results.filter((card) => {
                        return card.paymentMethod !== walletPaymentsName.debitOneClick
                    })
                    setCardsList(_cardsList)

                    if (_cardsList.length) {
                        _cardsList.map((card) => {
                            if (card.isFavorite) {
                                _setDataPayment(card)
                            }
                        })
                    }
                } else {
                    if (data.status >= 500) {
                        setTimeout(() => {
                            PubSub.dispatch('open_snackbar', {
                                TitleMobile: 'Error al consultar sus Tarjetas',
                                TitleDesktop: `Error al consultar sus Tarjetas`,
                                timer: 15000,
                                titleButtonMobile: 'Recargar',
                                titleButtonDesktop: 'Recargar',
                                type: 'cardListError',
                                callback: () => {
                                    if (typeof window !== 'undefined') window.location.reload()
                                },
                            })
                        }, 0)
                    }
                    setLoading(false)
                    setCardsList([])
                }
                setLoading(false)
                setLoadingInit(false)
            })
            .catch(() => {
                setTimeout(() => {
                    PubSub.dispatch('open_snackbar', {
                        TitleMobile: 'Error al consultar sus Tarjetas',
                        TitleDesktop: `Error al consultar sus Tarjetas`,
                        timer: 15000,
                        titleButtonMobile: 'Recargar',
                        titleButtonDesktop: 'Recargar',
                        type: 'cardListError',
                        callback: () => {
                            if (typeof window !== 'undefined') window.location.reload()
                        },
                    })
                }, 0)
                setLoading(false)
                setCardsList([])
            })
    }

    const _setDataPayment = (card) => {
        if (!card) return false
        return WalletService.selectCard(card)
    }

    const changeMethod = () => {
        PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_CLOSE)
        setTimeout(() => {
            PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_OPEN, { ...value, cards: false, change: true, init: false })
        }, 500)
    }

    const { value } = payload
    const viewList = value?.cards || (value?.init && !!cardsList?.length)
    const disclaimer = value?.disclaimer;
    
    return (
        <div className="card-list-container">
            {(!viewList || disclaimer) && (
                <p className="drawer-payment-method-prime-disclaimer">
                    Solo medios de pago emitidos en Chile. Al guardar tu tarjeta en el sistema seguro de Webpay, Transbank validará tu
                    tarjeta con un cobro único de $50 que reversará posteriormente.
                </p>
            )}

            {isLoading ? (
                <div className={'cards-list-loader' + (loadingInit ? ' loader-init' : '')}>
                    <Loader />
                </div>
            ) : viewList ? (
                <PaymentMethodPrimeList
                    cardsList={cardsList}
                    isLoading={loadingInit}
                    setLoading={setLoading}
                    callbackOnClick={callbackOnClick}
                    callbackChangeView={changeMethod}
                />
            ) : (
                <AddCardsContent value={value} debit={false}/>
            )}
        </div>
    )
}

ContainerPaymentMethodPrime.propTypes = {
    payload: PropTypes.object,
    callbackOnClick: PropTypes.func,
}

export default ContainerPaymentMethodPrime
